import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleDealershipsScreen from "../../../container/Vehicles/VehicleDealershipsScreen";
import CreateVehicleDealerships from "../../../container/Vehicles/VehicleDealershipsScreen/CreateVehicleDealerships";

const VehicleDealershipsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_DEALERSHIPS.HOME}
          element={<VehicleDealershipsScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_DEALERSHIPS.CREATE}
          element={<CreateVehicleDealerships />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_DEALERSHIPS.EDIT}
          element={<CreateVehicleDealerships isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleDealershipsRoutes;
